import React, { useEffect, useState } from "react";
// import axios from "axios";
import axios from "../context/axios";

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [usersPerPage] = useState(10);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get("/users");
        setUsers(response.data.data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchUsers();
  }, []);

  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = users.slice(indexOfFirstUser, indexOfLastUser);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="min-h-screen py-2 px-2">
      <div className="max-w-7xl mx-auto p-6  rounded-lg ">
        <h2 className="text-4xl font-extrabold text-indigo-600 mb-8">
          User List
        </h2>

        <div className="overflow-x-auto rounded-md border border-gray-200 shadow-sm">
        <table className="min-w-full text-sm bg-white">
  <thead className="bg-indigo-50 text-indigo-600">
    <tr>
      <th className="py-3 px-4 text-center border-b">Sr No.</th>
      <th className="py-3 px-6 text-left border-b">Name</th>
      <th className="py-3 px-6 text-left border-b">Email</th>
      <th className="py-3 px-6 text-left border-b">Country</th>
      <th className="py-3 px-6 text-left border-b">Mobile</th>
      <th className="py-3 px-6 text-left border-b">Role</th>
    </tr>
  </thead>
  <tbody>
    {currentUsers.map((user, index) => (
      <tr
        key={user._id}
        className="hover:bg-indigo-50 transition-colors"
      >
        <td className="py-3 px-4 text-center border-b text-gray-800">
          {index + 1}
        </td>
        <td className="py-3 px-6 border-b text-gray-800">{user.name}</td>
        <td className="py-3 px-6 border-b text-gray-800">{user.email}</td>
        <td className="py-3 px-6 border-b text-gray-800">{user.country}</td>
        <td className="py-3 px-6 border-b text-gray-800">{user.mobile}</td>
        <td className="py-3 px-6 border-b">
          {user.isAdmin ? (
            <span className="text-green-600 font-semibold">Admin</span>
          ) : (
            <span className="text-gray-600">User</span>
          )}
        </td>
      </tr>
    ))}
  </tbody>
</table>
        </div>

        {/* Pagination */}
        <div className="mt-8 flex justify-center">
          <nav>
            <ul className="flex gap-4">
              <li>
                <button
                  onClick={() => paginate(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg transition hover:bg-gray-300 disabled:opacity-50"
                >
                  Previous
                </button>
              </li>
              {[...Array(Math.ceil(users.length / usersPerPage))].map(
                (_, index) => (
                  <li key={index}>
                    <button
                      onClick={() => paginate(index + 1)}
                      className={`px-4 py-2 rounded-lg transition ${
                        currentPage === index + 1
                          ? "bg-indigo-600 text-white"
                          : "bg-gray-200 text-gray-800"
                      }`}
                    >
                      {index + 1}
                    </button>
                  </li>
                )
              )}
              <li>
                <button
                  onClick={() => paginate(currentPage + 1)}
                  disabled={
                    currentPage === Math.ceil(users.length / usersPerPage)
                  }
                  className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg transition hover:bg-gray-300 disabled:opacity-50"
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default UserList;
